import React from 'react'

const Resendotp = () => {
  return (
    <div>
      
    </div>
  )
}

export default Resendotp
